import React from 'react';

import { Checkbox } from '@components/common';

import { uuid } from '@utils/common';

const SelectColumnHeader = (props: any) => {
	const {
		table: {
			getToggleAllRowsSelectedHandler,
			getIsAllRowsSelected,
			getIsSomeRowsSelected,
		},
	} = props;

	const isChecked = getIsAllRowsSelected();

	const onChangeForTable = getToggleAllRowsSelectedHandler();

	const isIndefinite = getIsSomeRowsSelected();

	return (
		<Checkbox
			checked={isChecked}
			isIndefinite={isIndefinite}
			name={`all-checkbox-${uuid()}`}
			onChangeForTable={onChangeForTable}
		/>
	);
};

export default SelectColumnHeader;
